export const generateSequenceName = (names, prefix) => {
    const namesSet = names instanceof Set ? names : new Set([...names]);
    let name = '';
    let idx = 1;
    while (!name) {
        const potentialName = prefix + idx;
        if (!namesSet.has(potentialName)) {
            name = potentialName;
        }
        else {
            idx++;
        }
    }
    return name;
};
//# sourceMappingURL=nameGenerator.utils.js.map